import cn from 'classnames';

import LinkList from 'components/link-list/LinkList';

import { ILinkLists, INestedLink_Item } from 'source/NFR.types';

interface ColumnsWithCount {
  0: INestedLink_Item[];
  1: INestedLink_Item[];
  count: number;
}

const split = (links: INestedLink_Item[]) => {
  const half =
    links?.reduce((acc, item) => {
      if (!item.items) return acc + 1;
      return acc + item.items.length;
    }, 0) / 2;

  const columns = links?.reduce<ColumnsWithCount>(
    (acc, item, i) => {
      if (i === 0) acc.count = 0;
      const savedCount = acc.count;

      if (!item.items) acc.count += 1;
      else acc.count += item.items.length;

      const previousCountIsCloser = Math.abs(half - savedCount) < Math.abs(half - acc.count);
      if (previousCountIsCloser) acc[1].push(item);
      else acc[0].push(item);
      return acc;
    },
    { 0: [], 1: [], count: 0 }
  );

  const onlyFilledColumns = [columns[0], columns[1]].filter(column => column.length);

  return onlyFilledColumns;
};

interface LinkListsProps extends ILinkLists {
  singleColumn?: boolean;
}

const LinkLists: React.FC<LinkListsProps> = ({ nestedLinks = [], singleColumn }) => {
  const columns = split(nestedLinks);

  return (
    <div className={cn('link-lists', { '-single-column': singleColumn })}>
      {columns?.map((column, i) => (
        <LinkList
          key={'link-list-' + i}
          className="link-lists--column"
          nestedLinks={column}
          linkTheme="actionLink"
          theme="portfolio"
          withIcon
          items={[]}
          onPageEditing={{ items: '' }}
        />
      ))}
    </div>
  );
};

LinkLists.displayName = 'LinkLists';

export default LinkLists;
